import { render, staticRenderFns } from "./AdvAllTpyeStatic.vue?vue&type=template&id=00b13d06&scoped=true"
import script from "./AdvAllTpyeStatic.vue?vue&type=script&lang=js"
export * from "./AdvAllTpyeStatic.vue?vue&type=script&lang=js"
import style0 from "./AdvAllTpyeStatic.vue?vue&type=style&index=0&id=00b13d06&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b13d06",
  null
  
)

export default component.exports